import { Set as ImmutableSet } from 'immutable';

// @ts-expect-error untyped dependency
import User, { UserKeys } from 'FormsCommonComponents/lib/User';
function createAction(name) {
  return `@@user/${name}`;
}
export const SET_USER = createAction('SET_USER');
export const setUser = user => ({
  type: SET_USER,
  user: new User({
    [UserKeys.USER_ID]: user.user_id,
    [UserKeys.EMAIL]: user.email,
    [UserKeys.FIRST_NAME]: user.first_name,
    [UserKeys.LAST_NAME]: user.last_name,
    [UserKeys.LOCALE]: user.locale,
    [UserKeys.LANG_ENABLED]: user.lang_enabled,
    [UserKeys.SCOPES]: ImmutableSet(user.scopes),
    [UserKeys.SIDEKICK_USER_ID]: user.sidekick_user_id,
    [UserKeys.ROLES]: user.roles,
    [UserKeys.PARTNER]: user.partner,
    [UserKeys.ACTING_USER_ID]: user.acting_user_id,
    [UserKeys.TEAMS]: user.teams,
    [UserKeys.EMAILS]: user.emails,
    [UserKeys.CREATED_AT]: user.created_at
  })
});